import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate, useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import i18n from 'i18next';

import Homepage from './pages/Homepage'
import Login from './pages/Login';
import ProductsPage from './pages/ProductsPage';
import LicenseScan from './pages/LicenseScan';
import UserAccount from './pages/UserAccount';
import Message from './pages/PayPal/Message';
import Checkout from './pages/PayPal/Checkout';
import ProtectedRoutes from './helpers/ProtectedRoutes';
import ScrollToTop from './components/scrolls/ScrollToTop';
import TechFooter from './components/TechFooter';
import Document from './pages/Document';
import DrivingLicensePage from './pages/DrivingLicense';
import CaptureTest from './pages/CaptureTest';
import { languages } from './constants';

function RedirectHandler() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const lng = searchParams.get('lng');
    if (lng && languages.some(l => l.code === lng)) {
      i18n.changeLanguage(lng);
      const pathParts = location.pathname.split('/');
      const currentLang = pathParts[1];
      const isCurrentLangValid = currentLang && languages.some(l => l.code === currentLang);
      if (!isCurrentLangValid || currentLang !== lng) {
        // Redirect to path-based with correct lang
        const restOfPath = isCurrentLangValid ? location.pathname.substring(currentLang.length + 1) : location.pathname;
        const newPath = `/${lng}${restOfPath}`;
        navigate(newPath, { replace: true });
      }
    } else {
      // No lng param, check if need to redirect to default lang
      const pathParts = location.pathname.split('/');
      const currentLang = pathParts[1];
      const isCurrentLangValid = currentLang && languages.some(l => l.code === currentLang);
      if (!isCurrentLangValid) {
        // Redirect to default lang, preserving query params
        navigate(`/en${location.search}`, { replace: true });
      }
    }
  }, [searchParams, location.pathname, navigate]);

  return null;
}

export default function App() {
  const { t, i18n: i18nInstance } = useTranslation();

  useEffect(() => {
    const currentLang = i18nInstance.language || 'en';
    const normalizedLang = currentLang.split('-')[0];
    const isRtl = normalizedLang === 'ar' || normalizedLang === 'he';

    document.documentElement.lang = normalizedLang;
    document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
  }, [i18nInstance.language]);

  return (
    <div className='App'>
      <Router>
        <RedirectHandler />
        <ScrollToTop>
          <Routes>
            <Route path="/:lang/*" element={
              <Routes>
                <Route path="/" element={<Homepage />} />
                <Route path="login" element={<Login />} />
                <Route path="products" element={<ProductsPage />} />
                <Route path="japan-driving-license" element={<DrivingLicensePage />} />
                <Route path="thailand-driving-license" element={<DrivingLicensePage />} />
                <Route path="italy-driving-license" element={<DrivingLicensePage />} />
                <Route path="capture-test" element={<CaptureTest />} />
                <Route element={<ProtectedRoutes />}>
                  <Route path="postPayment" element={<Message />} />
                  <Route path="checkout" element={<Checkout />} />
                  <Route path="license" element={<LicenseScan />} />
                  <Route path="account" element={<UserAccount />} />
                  <Route path="document/:docId" element={<Document />} />
                </Route>
                <Route
                  path="*"
                  element={
                    <main style={{ padding: '1rem' }}>
                      <p>{t('nothing_page')}</p>
                    </main>
                  }
                />
              </Routes>
            } />
          </Routes>
        </ScrollToTop>
        <TechFooter enableLogRocket={true} />
      </Router>
    </div>
  );
}
